import React, { useState, useEffect } from "react";
import App from "./App";
import { useGraph } from "./lib/useGraph";
import { WebSocketProvider } from '../contexts/WebSocketContext';
import { AppSyncProvider } from '../contexts/AppSyncContext';
import { Welcome } from "./Welcome";
import { NoLoad } from "./NoLoad";
import { Loading } from "./Loading";

export default function Init() {

    const maxRetries = 1;
    const [retryCount, setRetryCount] = useState(0);
    const [content, setContent] = useState(<Loading></Loading>);

    //get your profile
    const { loading, error, data, reload } = useGraph(
        async (graph) => {
            let me = await graph.api("/me").get();
            return { me };
        }
    );

    const canRetry = retryCount < maxRetries;

    const handleRetry = () => {
        if (!canRetry) {
            return;
        }

        setRetryCount(current => current + 1);
        reload();
    };


    useEffect(() => {
        if (error && !data) {
            console.log(JSON.stringify(error));

            if (error.body) {
                console.log("BODY:::", error.body);
                let re = /(AADSTS\d+)/g;
                const errCodes = error.body.match(re);

                //https://docs.microsoft.com/en-us/azure/active-directory/develop/reference-aadsts-error-codes
                if (errCodes) {
                    switch (errCodes[0]) {
                        case "AADSTS65001":
                        case "AADSTS500011":
                            //this means we are the first time using this app 
                            //instead of just doing reload I am going to load the initial screen
                            setContent(<Welcome reload={reload}></Welcome>);
                            break;
                        default:
                            setContent(<NoLoad reload={canRetry ? handleRetry : undefined} message={`An unexpected error occurred, ${errCodes[0]}`}></NoLoad>);
                            break;

                    }

                }
                else{
                    setContent(<NoLoad reload={canRetry ? handleRetry : undefined} message={`An unexpected error occurred, please try again, ${error.body}`}></NoLoad>);
                }

            }
            else {
                if (error.code == 'ErrorWithCode.InternalError') {
                    console.log("Maybe not running in teams??")
                    setContent(<NoLoad message="This App only works inside of Teams, if you are inside of teams please reload and try again"></NoLoad>);
                }
                else {
                    setContent(<NoLoad reload={canRetry ? handleRetry : undefined} message="Looks like we can't gain access to the permissions needed, please contact your office 365 admin"></NoLoad>);
                }
            }
        }
        else if (data) {
            setContent((
                <WebSocketProvider>
                    <AppSyncProvider>
                        < App />
                    </AppSyncProvider>
                </WebSocketProvider >
            ));
        }
    }, [error, data]);


    return content;
}